"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectComparisonHandler = void 0;
function includesHandler(list, value) {
    return list.includes(value);
}
var resultIncludesFilterHandler = function (resultValue, filterValues) {
    if (!Array.isArray(resultValue))
        return false;
    var list = resultValue;
    return includesHandler(list, filterValues);
};
var filterIncludesResultHandler = function (resultValue, filterValues) {
    if (!Array.isArray(filterValues))
        return false;
    var list = filterValues;
    return includesHandler(list, resultValue);
};
var selectComparisonHandler = function (resultValue, filterValues) {
    var resultIsArray = Array.isArray(resultValue);
    var filterIsArray = Array.isArray(filterValues);
    if (resultIsArray) {
        return resultIncludesFilterHandler(resultValue, filterValues);
    }
    if (filterIsArray) {
        return filterIncludesResultHandler(resultValue, filterValues);
    }
    return filterValues === resultValue;
};
exports.selectComparisonHandler = selectComparisonHandler;
//# sourceMappingURL=selectComparisonHandler.js.map